import {RouteObject} from 'react-router';
import {RouteType} from './routeType';

export default function mapRouteTypeToRoute<T extends object>(route: RouteType<T>, props?: T): RouteObject {
  const Component = route.component;
  return {
    path: route.path,

    element: <Component {...((props || {}) as T)} />,
  };
}
